/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import { MaintenanceComponent } from '@/shared/maintenance/maintenance.component';
import { MAINTENANCE_CONFIG } from '@/shared/maintenance.token';

const microserviceSettings = environment.webServices['WSMPApplicationSettings'];
const CONFIG_URL = `${microserviceSettings.path}/appsrv/get-maintenance-mode`;
const HOURS_INTERVAL = 1;
const FETCH_INTERVAL = HOURS_INTERVAL * 60 * 60 * 1000;

async function getConfig() {

  const cachedConfig = localStorage.getItem('bootstrap_config');

  const lastFetch = localStorage.getItem('bootstrap_last_fetch');

  const now = Date.now();

  const shouldRefresh = !lastFetch || now - Number(lastFetch) > FETCH_INTERVAL;

  // Verificar si ya pasaron la X horas
  if (shouldRefresh) {

    try {
      const languageId = navigator.language.split('-')[0].toUpperCase();

      const response = await fetch(
        `${CONFIG_URL}/${languageId}`,
        {
          cache: 'no-store'
        }
      );

      if (response.ok) {
        const { data } = await response.json();
        localStorage.setItem('bootstrap_config', JSON.stringify(data));
        localStorage.setItem('bootstrap_last_fetch', now.toString());
        return data;
      }

    } catch (error) {
      console.error(error);
    }
  }

  return cachedConfig
    ? JSON.parse(cachedConfig)
    : {
      isMaintenance: false,
      message: ''
    };

}

async function bootstrap() {

  const config =
    await getConfig();

  if (config.isMaintenance) {

    await bootstrapApplication(
      MaintenanceComponent,
      {
        providers: [
          {
            provide: MAINTENANCE_CONFIG,
            useValue: config
          }
        ]
      }
    );
    return;
  }

  bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
}

if (environment.sentry.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      Sentry.browserTracingIntegration(),
      // Registers the Replay integration,
      // which automatically captures Session Replays
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
        autoInject: false,
        enableScreenshot: false,
        showBranding: false,
        isNameRequired: true,
        isEmailRequired: true,
        colorScheme: 'light',
        useSentryUser: { name: 'fullName', email: 'email' }
      })
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: environment.sentry.tracesSampleRate,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: environment.sentry.tracePropagationTargets,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate,
    replaysOnErrorSampleRate: environment.sentry.replaysOnErrorSampleRate
  });
}

bootstrap();

